export default "__VITE_ASSET__e2c18ae7__"